import { render, staticRenderFns } from "./FeedDeliverySummary.vue?vue&type=template&id=785f7470&scoped=true"
import script from "./FeedDeliverySummary.vue?vue&type=script&lang=ts"
export * from "./FeedDeliverySummary.vue?vue&type=script&lang=ts"
import style0 from "./FeedDeliverySummary.vue?vue&type=style&index=0&id=785f7470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785f7470",
  null
  
)

export default component.exports